import { produce } from "immer";
import { ActionType, createReducer } from "typesafe-actions";
import { tokenHandler } from "@shared/utils";

import { AuthStateType } from "../interface";
import * as actions from "./actions";

type Action = ActionType<typeof actions>;

export const initialState: AuthStateType = {
  authentificated: !!tokenHandler.get(),
  activateUserInfo: null,
};

const reducer = createReducer<AuthStateType, Action>(initialState)
  .handleAction(actions.login.success, (state) =>
    produce(state, (nextState) => {
      nextState.authentificated = true;
    }),
  )
  .handleAction(actions.activateAccount.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.activateUserInfo = action.payload;
    }),
  )
  .handleAction(actions.logout.success, (state) =>
    produce(state, (nextState) => {
      nextState.authentificated = false;
    }),
  );

export { reducer as AuthReducer };
